import { ListSubscribersQuery } from "~frontend/__generated__/graphql";
import { useSubaccount } from "~frontend/providers/SubaccountProvider";

export type Subscriber = ListSubscribersQuery["listSubscribers"][0];

export function useSubscriberLink(): (subscriber: Subscriber) => string {
  const { subaccountLink } = useSubaccount()!;
  return subscriber =>
    subaccountLink(
      `/threads?search_type=contact&search=${encodeURIComponent(subscriber.phoneNumber)}&messaging_strategies=SHORT_CODE&thread=${subscriber.threadId}`
    );
}

export function subscriberIsOptedOut(subscriber: Subscriber): boolean {
  return !!subscriber.optOuts.find(o => !o.deletedAt);
}
